import React from "react"

export default function Back() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <path d="M17.1188 5.82679L15.6885 4.39648L7.68848 12.3965L15.6885 20.3965L17.1188 18.9662L10.5491 12.3965L17.1188 5.82679Z" fill="#151A35" />
      </svg>
   )
}